import { Box } from '@mui/material';
import { DAY_LABELS } from './constants';

const WEEKDAY_COLOR  = '#0abde3';
const WEEKEND_COLOR  = '#ffa502';
const OFF_COLOR      = 'rgba(255,255,255,0.08)';
const OFF_TEXT       = 'rgba(255,255,255,0.18)';

const DaysRow = ({ daysOfOperation = '', size = 20 }) => (
  <Box display="flex" gap={0.25}>
    {[1, 2, 3, 4, 5, 6, 7].map((d) => {
      const on      = daysOfOperation.includes(String(d));
      const weekend = d >= 6;
      const bg      = on ? (weekend ? WEEKEND_COLOR : WEEKDAY_COLOR) : OFF_COLOR;
      const radius  = Math.round(size * 0.2);

      return (
        <Box
          key={d}
          sx={{
            width: size,
            height: size,
            borderRadius: `${radius}px`,
            bgcolor: bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.6 + 'px',
            fontFamily: 'monospace',
            fontWeight: 500,
            color: on ? 'text.primary' : OFF_TEXT,
            letterSpacing: 0,
            userSelect: 'none',
            flexShrink: 0,
          }}
        >
          {DAY_LABELS[d][0]}
        </Box>
      );
    })}
  </Box>
);

export default DaysRow;
